import React, { useCallback, useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ScrollPanel } from "primereact/scrollpanel";
import InsurancePlan from "../../../../_shared/InsurancePlan/InsurancePlans";
import VehicleInfo from "../../../../_shared/VehicleInfo/VehicleInfo";
import VehicleDriverInfoWrapper from "./VehicleDriverInfo.style";
import InsuredDrivers from "../../../../_shared/InsuredDrivers/InsuredDrivers";
import SubFooter from "../../components/subFooter/subFooter";
import * as globalUtils from "../../../../helpers/utils";
import * as utils from "../../helpers/utils";
import * as renewalService from "../../../../services/renewal-service";
import { renewalActions } from "../../../../redux/actions";
import motor from "../../../../assets/images/icons/motor.svg";
import MoreCoverageCard from "../../components/moreCoverageCard/MoreCoverageCard";
import { Toast } from "primereact/toast";
import { createQuotation } from "../../../../services/renewal-service";
import { submitCRMCampaignApi } from "../../../../services/crmApi";

const VehicleDriverInfo = (props) => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [featureLoading, setFeatureLoading] = useState(false);
  const [vehicleValueError, setVehicleValueError] = useState("");
  const [canProceed, setCanProceed] = useState(true);
  const { renewalCarColor, saveClicked, driverRegistered } = useSelector(
    (state) => state.renewal
  );
  const messageToastr = useRef(null);
  const quotationData = useSelector((state) => state.renewal.quotationDetails);
  const quotationDataPrepared = utils.prepareQuotationData(
    quotationData,
    renewalCarColor
  );
  const proposalData = useSelector((state) => state.renewal.proposalDetails);
  const policyData = useSelector((state) => state.renewal.policyData);
  const uid = useSelector((state) => state.renewal.uid);

  const chosenProductCode = useSelector(
    (state) => state.renewal.chosenProductCode
  );
  const defaultValues = useSelector(
    (state) => state.renewal.defaultValuesDetails
  );

  useEffect(() => {
    quotationData.vehicleDetails.vehicleDetailsArray[0].vehicleValue = parseInt(
      quotationData.vehicleDetails.vehicleDetailsArray[0].vehicleValue.length >
        0
        ? quotationData.vehicleDetails.vehicleDetailsArray[0].vehicleValue
        : defaultValues.vehicleValue.avg
    ).toString();
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getChoosenProposal = useCallback(
    (productCode = chosenProductCode) => {
      if (proposalData?.proposals?.proposalsArray) {
        return proposalData.proposals.proposalsArray.find(
          (ele) => ele.productSubCode === productCode
        );
      }
      return null;
    },
    [chosenProductCode, proposalData]
  );

  const getSelectedFeatures = () => {
    const selectedFeatures =
      quotationData.vehicleDetails.vehicleDetailsArray[0].selectedFeatures;
    if (selectedFeatures && selectedFeatures.selectedFeatures) {
      return selectedFeatures.selectedFeatures;
    }
    return [];
  };

  const getFeatures = () => {
    const choosenProposal = getChoosenProposal();
    if (choosenProposal) {
      return choosenProposal.vehicleArray[0].applicableFeatureGroup.filter(
        (ele) =>
          ele.featureItems &&
          ele.featureItems.featureItemsArray &&
          Array.isArray(ele.featureItems.featureItemsArray)
      );
    }
    return [];
  };

  const updateSelectionFeatures = (data) => {
    const myQutationData = { ...quotationData };
    myQutationData.vehicleDetails.vehicleDetailsArray[0].selectedFeatures =
      data && data.length
        ? {
            selectedFeatures: data.map((ele) => {
              return { featureCode: ele };
            }),
          }
        : null;

    dispatch(renewalActions.updateQuotationDetails(myQutationData));
    getProposal(chosenProductCode);
  };
  const [selectedDetails, setSelectedDetails] = useState({});

  const getDriversList = () => {
    return quotationData.vehicleDetails.vehicleDetailsArray[0]
      .vehicleDriverDetails.vehicleDriverDetailsArray;
  };

  const updateDriversList = (driverList) => {
    const myQutationData = { ...quotationData };
    myQutationData.vehicleDetails.vehicleDetailsArray[0].vehicleDriverDetails.vehicleDriverDetailsArray =
      driverList;
    dispatch(renewalActions.updateQuotationDetails({ ...myQutationData }));
    getProposal(chosenProductCode);
  };

  const updateLoaderValue = (value) => {
    dispatch(renewalActions.updateLoading(value));
  };

  const getProposal = useCallback(
    (productCode = "ALL", data) => {
      setFeatureLoading(true);
      const promiseArr = [
        renewalService.getProposalDetails({
          ...utils.buildProposalRequest(
            data ?? quotationData,
            policyData,
            productCode,
            renewalCarColor.colorCode
          ),
          languageCode: globalUtils.getOneLetterLanguageCode(
            props.i18n.language
          ),
        }),
      ];

      if (productCode === "ALL") {
        promiseArr.push(
          renewalService.getProposalDetails({
            ...utils.buildProposalRequest(
              data ?? quotationData,
              policyData,
              policyData.productCode
            ),
            languageCode: globalUtils.getOneLetterLanguageCode(
              props.i18n.language
            ),
          })
        );
      }

      Promise.allSettled(promiseArr)
        .then(([proposalProductCode, renewalProposal]) => {
          // if(result[0].reason == 'full')
          setFeatureLoading(false);
          if (
            proposalProductCode.status === "rejected" ||
            proposalProductCode.value.data.resultCode !== "S"
          ) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "error_displayed",
              error_location: "Motor Insurance Renew",
              funnel_step: uid ? "step_0" : "step_4",
              error_messages: proposalProductCode?.value?.data?.resultMessage,
            });
            // messageToastr.current.show({
            //   severity: "error",
            //   summary: "Error Message",
            //   detail: proposalProductCode?.value?.data?.resultMessage,
            //   life: 10000,
            // });
            setCanProceed(false)
            return;
          }
          if (
            renewalProposal &&
            (renewalProposal.status === "rejected" ||
              renewalProposal.value.data.resultCode !== "S")
          ) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "error_displayed",
              error_location: "Motor Insurance Renew",
              funnel_step: uid ? "step_0" : "step_4",
              error_messages: proposalProductCode?.value?.data?.resultMessage,
            });
            // messageToastr.current.show({
            //   severity: "error",
            //   summary: "Error Message",
            //   detail: renewalProposal.value.data.resultMessage,
            //   life: 10000,
            // });
            return;
          }
          let resultProposal = proposalProductCode.value.data;
          if (
            productCode === "ALL" &&
            renewalProposal &&
            renewalProposal.status === "fulfilled" &&
            renewalProposal.value &&
            renewalProposal.value.data
          ) {
            const renewalProposalData = renewalProposal.value.data;
            resultProposal.proposals.proposalsArray =
              resultProposal.proposals.proposalsArray.filter(
                (p) => p.productSubCode !== policyData.productCode
              );
            resultProposal.proposals.proposalsArray.push(
              renewalProposalData.proposals.proposalsArray[0]
            );
            dispatch(
              renewalActions.updateProposalDetails({ ...resultProposal })
            );
          } else {
            // const actualProposal = { ...proposalData };
            // console.log("DHT YES", proposalData, resultProposal.proposals.proposalsArray);
            // actualProposal.proposals.proposalsArray =
            //   actualProposal.proposals.proposalsArray.filter(
            //     (p) =>
            //       p.productSubCode !==
            //       resultProposal.proposals.proposalsArray[0].productSubCode
            //   );
            // console.log("DHT", resultProposal.proposals.proposalsArray[0]);
            // actualProposal.proposals.proposalsArray.push(
            //   resultProposal.proposals.proposalsArray[0]
            // );
            // dispatch(
            //   renewalActions.updateProposalDetails({ ...actualProposal })
            // );

            let proposal = {
              productFamilyCode: productCode,
              proposals: {
                proposalsArray: resultProposal.proposals.proposalsArray[0],
              },
            };
            dispatch(renewalActions.updateProposalDetails(proposal));
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              funnel_step: uid ? "step_0" : "step_4",
              step_name: uid
                ? "motor_policy_directLink_renewal_add_to_cart"
                : "motor_insurance_login_renew_add_to_cart",
              items: [
                {
                  item_name: uid
                    ? "Motor Insurance Direct Link Renew"
                    : "Motor Insurance Login Renew",
                  item_category: "Motor Insurance",
                  item_class: "Individual",
                  is_car_owner: "Yes",
                  vehicle_year:
                    quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                      ?.yearOfManufacture,
                  vehicle_brand:
                    quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                      ?.modelMake,
                  vehicle_model:
                    quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                      ?.makeName,
                  driver_yob:
                    quotationData?.customerDetails?.policyHolder[0]?.gregDob,
                  items: resultProposal,
                  addons:
                    quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                      ?.selectedFeatures,
                },
              ],
            },
          });
        })
        .catch((err) => {
          setFeatureLoading(false);
        });
    },
    [dispatch, props.i18n.language, quotationData]
  );

  useEffect(() => {
    getProposal();
  }, [props.i18n.language]);

  // useEffect(() => {
  //   if (renewalCarColor?.colorCode?.length > 0) {
  //     getProposal();
  //   }
  // }, [renewalCarColor]);

  useEffect(() => {
    setSelectedDetails(getChoosenProposal());
  }, [getChoosenProposal]);

  const onSelectProduct = (productCode) => {
    if (chosenProductCode) {
      getProposal(productCode);
    }
    setSelectedDetails(getChoosenProposal(productCode));
    dispatch(renewalActions.updateChoosenProduct(productCode));
  };

  const updateObjectForGetProposal = (data) => {
    dispatch(renewalActions.updateQuotationDetails(data));
    getProposal(chosenProductCode, data);
  };

  // const [quotationDataResponse, setQuotationDataResponse] = useState({});

  const createQoutation = useCallback(() => {
    setLoading(true);
    updateLoaderValue(true);
    let serviceCall = renewalService.createQuotation;
    if (utils.isRenewal(policyData, chosenProductCode)) {
      serviceCall = renewalService.renewQuotation;
    }
    const createQuotationRequest = {
      ...utils.buildQuotationAPIRequest(
        quotationData,
        policyData,
        chosenProductCode,
        driverRegistered
      ),
    };
    // dispatch(update)
    serviceCall({
      ...createQuotationRequest,
      languageCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
      proposalNumber: selectedDetails?.proposalNumber,
    })
      .then((response) => {
        setLoading(false);
        submitCRMCampaignApi(response.data.quotationNumber, "MMR");
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            funnel_step: uid ? "step_1" : "step_5",
            step_name: uid
              ? "motor_policy_directLink_renewal_begin_checkout"
              : "motor_insurance_login_renew_begin_checkout",
            items: [
              {
                item_name: uid
                  ? "Motor Insurance Direct Link Renew"
                  : "Motor Insurance Login Renew",
                item_category: "Motor Insurance",
                item_class: "Individual",
                is_car_owner: "Yes",
                vehicle_year:
                  quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                    ?.yearOfManufacture,
                vehicle_brand:
                  quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                    ?.modelMake,
                vehicle_model:
                  quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                    ?.makeName,
                driver_yob:
                  quotationData?.customerDetails?.policyHolder[0]?.gregDob,
                items: proposalData,
                addons:
                  quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                    ?.selectedFeatures,
              },
            ],
          },
        });
        if (response.data.resultCode == "S") {
          quotationDataPrepared.premium = response.data.premium;
          quotationDataPrepared.idNumber = response.data.idNumber;
          window.dataLayer = window.dataLayer || [];
          // setQuotationDataResponse(response.data);
          navigate("/renewal/payment", {
            replace: false,
            state: { quotationDataResponse: response.data },
          });
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: "Motor Insurance Renew",
            funnel_step: uid ? "step_1" : "step_5",
            error_messages: response.data.resultMessage,
          });
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: response.data.resultMessage,
            life: 10000,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: "Motor Insurance Renew",
          funnel_step: uid ? "step_1" : "step_5",
          error_messages: err.message,
        });
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: err.message,
          life: 10000,
        });
      });
  }, [quotationData, chosenProductCode, props.i18n.language]);

  useEffect(() => {
    updateLoaderValue(loading);
  }, [loading]);

  useEffect(() => {
    updateLoaderValue(featureLoading);
  }, [featureLoading]);
  useEffect(() => {
    // on destroy page
    return () => {
      updateLoaderValue(false);
    };
  }, []);

  return (
    <>
      <Toast ref={toast} />
      <VehicleDriverInfoWrapper>
        <Toast ref={messageToastr} />
        <VehicleInfo quotationData={quotationDataPrepared} expand={false} />
        {proposalData && proposalData.proposals && (
          <InsurancePlan
            proposals={proposalData.proposals.proposalsArray}
            onSelectProduct={onSelectProduct}
            isRenewal={true}
            quotationData={quotationData}
            renewalObject={policyData}
            chosenProductCode={chosenProductCode}
            defaultValues={defaultValues}
            updateObjectForGetProposalHandler={updateObjectForGetProposal}
            choosenProposal={getChoosenProposal()}
            vehicleValueError={vehicleValueError}
            setVehicleValueError={setVehicleValueError}
          />
        )}
        {chosenProductCode && (
          <>
            <MoreCoverageCard
              features={getFeatures()}
              selectedFeatures={getSelectedFeatures()}
              updateSelectedFeatures={updateSelectionFeatures}
            />
            <InsuredDrivers
              driverList={getDriversList()}
              updateDriversListHandler={updateDriversList}
            />
          </>
        )}
        {chosenProductCode && (
          <SubFooter
            handleClick={createQoutation}
            total={selectedDetails?.premium}
          />
        )}
      </VehicleDriverInfoWrapper>
    </>
  );
};

export default withTranslation()(VehicleDriverInfo);
